<template>
  <v-col :cols="attrs.cols">
    <div class="naming">
      <div v-if="attrs.add" class="mb-4 flex-wrap">
        <v-btn
          v-if="attrs.controls"
          class="mr-2"
          light
          rounded
          x-small
          @click="hideChildren = !hideChildren"
          >{{ hideChildren ? 'All' : 'Compact' }}</v-btn
        >

        <v-btn
          v-if="attrs.controls"
          class=" ml-2 mr-2"
          light
          rounded
          x-small
          @click="editMode = !editMode"
          >{{ editMode ? 'Close' : 'Edit' }}</v-btn
        >

        <v-btn
          v-if="attrs.controls && !editMode"
          class="ml-2 mr-2"
          light
          rounded
          x-small
          @click="deleteList()"
          >Delete</v-btn
        >
        <v-btn
          v-if="editMode && attrs.controls"
          class="ml-2"
          light
          rounded
          x-small
          color="amber"
          @click="applyNameChange"
          >Apply</v-btn
        >
      </div>

      <div class="naming__header">
        <div
          v-if="editMode === false"
          class="d-flex justify-space-between align-items-center"
        >
          <div class="mb-4">
            <p class="text-h5">{{ item.title }}</p>
            <p class="text-h6 lh-1">{{ item.sentence }}</p>
            <div class="d-flex mt-2 flex-wrap" v-if="attrs.tags">
              <v-chip
                v-for="(tag, index) in item.categories"
                :key="`tag-${tag}-${index}`"
                small
                class="mr-1 mb-1"
              >
                {{ tag }}</v-chip
              >
            </div>

            <div class="d-flex mt-2 flex-wrap" v-if="attrs.tags">
              <v-chip
                v-for="(tag, index) in item.audiences"
                :key="`tag-${tag}-${index}`"
                small
                class="mr-1 mb-1"
              >
                {{ tag }}</v-chip
              >
            </div>

            <div v-if="attrs.note && item.body" class="mt-4">
              <article>
                <p class="text-caption text-uppercase mb-2">Description</p>
                <div class="pre-wrap" v-html="item.body"></div>
              </article>
            </div>

            <div v-if="attrs.historic && item.historical" class="mt-4">
              <article>
                <p class="text-caption text-uppercase mb-2">
                  Historical Narrative
                </p>
                <div class="pre-wrap" v-html="item.historical"></div>
              </article>
            </div>
          </div>
        </div>

        <div v-else>
          <ColForm
            :key="refItem.id"
            :new-item="refItem"
            :local="attrs.local"
            @update="updateList"
          />
        </div>
        <div
          v-if="!editMode && attrs.controls && attrs.add"
          class="d-flex justify-space-between"
        >
          <v-btn
            @click="addNewItem()"
            :color="cardForm ? 'grey' : 'amber'"
            class="mb-4"
            light
            rounded
            small
            >{{ cardForm ? 'Close' : '+' }}</v-btn
          >
        </div>

        <v-card v-if="cardForm" class="mb-4" elevation="2" outlined light>
          <v-card-title>Add a new items</v-card-title>

          <v-card-text>
            <ItemForm
              :key="`${newItem.id}-${editKey}`"
              :new-item="newItem"
              :colors="colors"
              :local="attrs.local"
              @submit="addItem"
              @cancel="cancel"
            />
          </v-card-text>
        </v-card>

        <div v-if="attrs.children">
          <div>
            <NestedDraggable
              :key="`nested-${item.id}`"
              :children="items"
              :attrs="attrs"
              :depth="0"
              :id="item.id"
              :local="attrs.local"
              :hide-children="hideChildren"
            />
          </div>
        </div>
      </div>
    </div>
  </v-col>
</template>

<script>
// @ is an alias to /src
import NestedDraggable from '@/views/user/exercises/offer-system/NestedDraggable'
import ItemForm from '@/views/user/exercises/offer-system/ItemForm'
import ColForm from '@/views/user/exercises/offer-system/ColForm'
import { checkPopulated } from '@/utils/types'

import { itemModel, initialState, colors } from './model'

export default {
  name: 'UserOfferCol',
  components: {
    NestedDraggable,
    ItemForm,
    ColForm
  },
  data() {
    return {
      items: this.value,
      refItem: this.item,
      newItem: { ...initialState },
      editMode: false,
      hideChildren: false,
      cardForm: false,
      editKey: 0,
      colors: colors
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: () => {}
    },
    attrs: {
      type: Object,
      deafult: () => {}
    }
  },
  watch: {
    value: {
      handler(val) {
        this.items = val
      },
      deep: true
    },
    items: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    },
    item: {
      handler(val) {
        // watch when a new item is passed from the parent and update our reference item
        this.refItem = val
      },
      deep: true
    }
    // refItem: {
    //   handler(val) {
    //     this.$emit("onEditList", val);
    //   },
    //   deep: true,
    // },
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
    applyNameChange() {
      // this will emit the new refItem abck to the parent to ass in the updated item into this component
      this.$emit('onChangeName', {
        newTitle: this.refItem.title,
        ...this.refItem
      })
      this.editMode = false
    },
    deleteList() {
      this.$emit('onDeleteList', this.item)
    },
    addNewItem() {
      // Object.assign(this.newItem, { ...itemModel });
      this.destroyProto()
      this.editKey++
      this.$nextTick(() => {
        this.cardForm = !this.cardForm
      })
    },
    addItem(ev) {
      console.log('add item', ev)
      const item = this.constructItem({ ...itemModel }, ev)
      item.id = new Date().valueOf()
      this.items.push(item)
      this.cardForm = false
      this.$emit('onEditList', ev)
    },
    destroyProto() {
      console.log('destroy proto from structure col')
      Object.assign(this.newItem, initialState())
      this.newItem.id = new Date().valueOf()
    },
    cancel() {
      this.cardForm = false
    },
    constructItem(model, item) {
      const obj = {}
      Object.keys(model).forEach(key => {
        obj[key] = checkPopulated(item[key])
      })

      return obj
    },
    updateList(ev) {
      this.$emit('onEditList', ev)
      this.editMode = false
    }
  }
}
</script>

<style lang="scss">
.delete {
  position: absolute !important;
  right: 0;
  top: 0;
  font-size: 1rem;
}
.naming {
  color: black;
}
</style>
